export class TimeseriesWidget {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "series",
            "baseName": "series",
            "type": "MetricTimeseries",
            "format": ""
        },
        {
            "name": "baselineSeries",
            "baseName": "baselineSeries",
            "type": "MetricTimeseries",
            "format": ""
        },
        {
            "name": "threshold",
            "baseName": "threshold",
            "type": "number",
            "format": "double"
        },
        {
            "name": "thresholdLabel",
            "baseName": "thresholdLabel",
            "type": "string",
            "format": ""
        },
        {
            "name": "chartKind",
            "baseName": "chartKind",
            "type": "TimeseriesChartKind",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TimeseriesWidget.attributeTypeMap;
    }
    constructor() {
    }
}
